module.exports = __webpack_public_path__ + "assets/milk-bottle-1.9d304dd6.svg";